import { ChangeDetectorRef, Component, NgZone, OnInit, OnDestroy } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { LoaderService } from '../loader.service';
import { Event } from '@angular/router';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { Subscription, debounceTime } from 'rxjs';

@Component({
  selector: 'app-loader',
  standalone: true,
  imports: [CommonModule, RouterModule, ReactiveFormsModule],
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.css']
})
export class LoaderComponent implements OnInit, OnDestroy {
  loadingprogress: boolean = false;
  progressValue: number = 0;
  stopProgress: boolean = false;
  progressColor: string = '';
  width: number = 10;
  
  private loaderSubscription: Subscription;
  private navigationSubscription: Subscription;
  private progressInterval: number | null = null;

  constructor(
    private loaderService: LoaderService,
    private router: Router,
    private cdr: ChangeDetectorRef,
    private ngZone: NgZone
  ) {
    // 🔥 Debounce loader state changes to prevent flickering
    this.loaderSubscription = this.loaderService.isLoading.pipe(
      debounceTime(100)
    ).subscribe(v => {
      this.ngZone.run(() => {
        this.loadingprogress = v;
        if (v) {
          this.startProgress();
        } else {
          this.stopProgress = true;
        }
      });
    });

    // 🔥 Optimize navigation observer
    this.navigationSubscription = this.router.events.subscribe((event: Event) => {
      this.navigationObserver(event);
    });
  }

  ngOnInit() {
  }

  ngOnDestroy() {
    // 🔥 Clean up subscriptions and intervals
    if (this.loaderSubscription) {
      this.loaderSubscription.unsubscribe();
    }
    if (this.navigationSubscription) {
      this.navigationSubscription.unsubscribe();
    }
    if (this.progressInterval) {
      clearInterval(this.progressInterval);
      this.progressInterval = null;
    }
  }

  private startProgress(): void {
    if (this.progressInterval) {
      clearInterval(this.progressInterval);
    }
    this.stopProgress = false;
    this.progressInterval = this.ngZone.runOutsideAngular(() => {
      return window.setInterval(() => {
        this.ngZone.run(() => {
          if (this.progressValue >= window.innerWidth || this.stopProgress) {
            this.progressValue = 0;
          } else {
            this.progressValue += 2; // 🔥 Faster progress
          }
          const element = document.getElementById("divbar");
          if (element) {
            element.style.width = this.progressValue + "px";
          }
        });
      }, 50); // 🔥 Faster interval
    });
  }

  private navigationObserver(event: Event): void {
    // 🔥 Optimized navigation observer
    // Progress bar is now handled by debounceTime in constructor
  }
}
